export { default } from "./ReviewsCountButton.jsx";
